import { createSlice } from '@reduxjs/toolkit';
import { createCompanyOtpLogin } from './api';
import { CompanyOtpLogin } from './api/interface';

interface InitialState {
  data: CompanyOtpLogin | null;
  isLoading: boolean;
  isError: boolean;
}

const initialState: InitialState = {
  data: null,
  isLoading: false,
  isError: false,
};

const companyOtpLoginSlice = createSlice({
  name: 'companyOtpLogin',
  initialState,
  reducers: {
    resetCompanyOtpLogin: (state) => {
      state.data = null;
      state.isLoading = false;
      state.isError = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createCompanyOtpLogin.pending, (state) => {
      state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(createCompanyOtpLogin.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.isError = false;
    });
    builder.addCase(createCompanyOtpLogin.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
    });
  },
});

export const { resetCompanyOtpLogin } = companyOtpLoginSlice.actions;
export default companyOtpLoginSlice.reducer;

